var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('appBar'),_c('v-content',[_vm._t("default")],2),_c('v-footer',{attrs:{"app":""}},[_c('bottomNav')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }